const usePermissionConfig = () => {
  return {
    /*
    * 删除
    * 控制：批量删除；删除
    * 跳转路由名称：
    * */
    DELETE: 'OPS-SPFW-ESPXX-SC',
  };
};

export default usePermissionConfig;
